module.exports = __webpack_public_path__ + "img/icon_addcart.47c89b47.svg";